import { type FC } from 'react';
import logoUrl from '@/assets/axis-finance-logo.png';

/**
 * AxisFinanceLogo — the official Axis Finance wordmark (white "A" + "AXIS
 * FINANCE" on the brand burgundy tile), shipped as the exact provided asset.
 *
 * The source image is 232×62 (~3.74:1). Pass `height` (px) and the width
 * scales to keep the aspect ratio. Use `rounded` to round the tile corners.
 */

const ASPECT = 232 / 62;

export interface AxisFinanceLogoProps {
  height?: number;
  className?: string;
  rounded?: boolean;
}

export const AxisFinanceLogo: FC<AxisFinanceLogoProps> = ({
  height = 32,
  className,
  rounded = true,
}) => (
  <img
    src={logoUrl}
    alt="Axis Finance"
    width={Math.round(height * ASPECT)}
    height={height}
    className={className}
    style={{ height, width: 'auto', borderRadius: rounded ? 6 : 0, display: 'block' }}
  />
);

export default AxisFinanceLogo;
